import React, { useEffect, useState } from "react";
import { generatePath, useNavigate } from "react-router-dom";
import { useTimeSince } from "../../../utils/dateUtils";
import "../design.scss";

import { useTranslation } from "react-i18next";

import styles from "../Design.module.scss";

import { ROUTES } from "../../../utils/Constant";

import DesignMenu from "../DesignMenu";
import DarkTooltip from "../../../common/components/DarkTooltip";

const DesignCard = (props) => {
  const navigate = useNavigate();

  const { t } = useTranslation();

  const { timeSince, dateFormatter } = useTimeSince();

  const {
    design,
    project,
    canDeleteDesign,
    canRenameDesign,
    canMoveDesign,
    canAddDesign,
  } = props;

  const [updatedTime, setUpdatedTime] = useState("");

  useEffect(() => {
    //latestUpdate is from DesignState, updated_at is from backend
    if (!design.latestUpdate) return;
    let timeInterval = setInterval(() => {
      const timeStamp = design.latestUpdate;
      let timeSinceUpdated = timeSince(timeStamp);
      if (timeSinceUpdated.includes("second")) {
        timeSinceUpdated = t("time.just_now");
      }
      setUpdatedTime(timeSinceUpdated);
    }, [1000]);
    return () => {
      clearInterval(timeInterval);
    };
  }, [design, t, dateFormatter, timeSince]);

  const onClick = () => {
    navigate(
      generatePath(ROUTES.STUDIO, {
        designId: design.id,
        projectId: project.id,
      })
    );
  };

  return (
    <React.Fragment>
      <div className={styles.container}>
        <div className={styles.imgContainer} onClick={onClick}>
          {design?.images?.map((image) => (
            <img
              src={image.url}
              alt={image.side}
              className={styles.img}
              key={image.side}
            />
          ))}
        </div>
        <div className={styles.cardActions}>
          <DarkTooltip
            title={design.name || t("design.untitled_design")}
            enterDelay={1000}
          >
            <div className={styles.dataLeft} onClick={onClick}>
              <span className={styles.title}>
                {design.name || t("design.untitled_design")}
              </span>
              <span className={styles.time}>{updatedTime}</span>
            </div>
          </DarkTooltip>
          <div className={styles.dataRight}>
            <DesignMenu
              designId={design.id}
              designName={design.name}
              projectId={project.id}
              canDeleteDesign={canDeleteDesign}
              canRenameDesign={canRenameDesign}
              canMoveDesign={canMoveDesign}
              canDuplicateDesign={canAddDesign}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default DesignCard;
